import { Component, OnInit } from '@angular/core';
import { MdDialog, MdDialogRef } from '@angular/material';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';

import { plainToClass } from 'class-transformer';
import { Observable } from 'rxjs/Observable';

import { OrganisationActivityCategory } from 'app/shared/components/activity/activity-details.model';
import { ActivityService } from 'app/shared/components/activity/activity.service';
import { ApplicationValue } from 'app/services/warmup/application-type.model';
import { WarmUpService, ApplicationTypeConstants } from 'app/services/warmup/warmup.service';
import { FormErrors } from 'app/shared/validators/generic-validators';
import { MessageService } from 'app/services/messages.service';
import { SnackBarService } from 'app/services/snackbar.service';

@Component({
  selector: 'editactivity',
  templateUrl: './edit-activity-details.component.html',
  styleUrls: ['./edit-activity-details.component.css']
})

/**
 * Component for edit activity.
 *
 * @author pankaj.khurana@vernuso.com (Pankaj Khurana)
 */
export class EditActivityDetailsComponent implements OnInit {
  activityCategoryDetails: OrganisationActivityCategory;
  activityCategoryForm: FormGroup;
  savingDetails: boolean = false;
  categoryTypes: ApplicationValue[];
  subCategoryTypes: ApplicationValue[];
  isOperationalCategory: boolean = false;
  entityId: number;

  constructor(
    public dialogRef: MdDialogRef<any>,
    private formBuilder: FormBuilder,
    private snackBarService: SnackBarService,
    private activityService: ActivityService,
    private warmUpService: WarmUpService
  ) { }

  ngOnInit() {
    this.buildForm();
  }

  buildForm() {
    this.activityCategoryForm = this.formBuilder.group({
      realEstateDevelopment: [''],
      realEstateTransactions: [''],
      realEstatePropertyServices: [''],
      royalties: [''],
      categoryType: [''],
      subCategoryType: ['']
    });
    this.updateActivityCategoryDetailsDataForm();
  }

  updateActivityCategoryDetailsDataForm(): void {
    if (this.activityCategoryDetails) {
      this.activityCategoryForm.patchValue({
        realEstateDevelopment: this.activityCategoryDetails.realEstateDevelopment,
        realEstateTransactions: this.activityCategoryDetails.realEstateTransactions,
        realEstatePropertyServices: this.activityCategoryDetails.realEstatePropertyServices,
        royalties: this.activityCategoryDetails.royalties,
        categoryType: this.activityCategoryDetails.activityCategory,
        subCategoryType: this.activityCategoryDetails.activitySubCategory,
      });
      this.categoryChange(this.activityCategoryDetails.activityCategory);
    }
  }

  categoryChange(selectedCategoryId: number) {
    this.isOperationalCategory = this.categoryTypes.some(obj => {
      return obj.id === selectedCategoryId && obj.name === 'Operational';
    });
  }

  onSubmit({ value, valid }): void {
    this.savingDetails = true;
    const categoryDetails = new OrganisationActivityCategory();
    categoryDetails.realEstateDevelopment = value.realEstateDevelopment;
    categoryDetails.realEstateTransactions = value.realEstateTransactions;
    categoryDetails.realEstatePropertyServices = value.realEstatePropertyServices;
    categoryDetails.royalties = value.royalties;
    categoryDetails.activityCategory = value.categoryType;
    categoryDetails.activitySubCategory = value.subCategoryType;
    categoryDetails.orgId = this.entityId;

    this.activityService.updateActivityCategoryDetails(categoryDetails)
      .subscribe(
      response => {
        this.savingDetails = false;
        if (response.flagResult) {
          this.dialogRef.close(categoryDetails);
        }
        this.callSnackBarService(response);
      },
      err => {
        this.savingDetails = false;
        this.callSnackBarService(err);
      }
      );
  }

  callSnackBarService(response: any) {
    this.snackBarService.showStatus(
      response,
      MessageService.UPDATED_ACTIVITY_SUCCESS,
      MessageService.ACTIVITY_FAILURE);
  }
}



// WEBPACK FOOTER //
// ./src/app/shared/components/activity/editactivitydetails/edit-activity-details.component.ts